import { IoIosPhonePortrait } from "react-icons/io";
import { FaWhatsapp } from "react-icons/fa";
import { LuMapPin } from "react-icons/lu";
import { MdOutlineMail } from "react-icons/md";
import { c_address, c_email, c_phone, c_whatsapp } from "../../../info/Info";

export const lists = [
    {
      icon: IoIosPhonePortrait,
      title: "CALL US:",
      text: c_phone,
    },
    {
      icon: MdOutlineMail,
      title: "MAIL US:",
      text: c_email,
    },
    {
      icon: FaWhatsapp,
      title: "Whatsapp US:",
      text: c_whatsapp,
    },
    {
      icon: LuMapPin,
      title: "VISIT US:",
      text: c_address,
    },
  ];

  export const teamList = [
    {
      url:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSyABtacOfSl8WS6TxLnDKIPRKqd7Pr2JUg5AGEg2LbYtX_KhmvxztFYeQjTTHdxKajkcs&usqp=CAU",
      name: "S Kumar",
      position: "(Managing Director)",
    },
    {
      url:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSyABtacOfSl8WS6TxLnDKIPRKqd7Pr2JUg5AGEg2LbYtX_KhmvxztFYeQjTTHdxKajkcs&usqp=CAU",
      name: "Shivam Kumar",
      position: "(Associate Director)",
    },
    {
      url:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSyABtacOfSl8WS6TxLnDKIPRKqd7Pr2JUg5AGEg2LbYtX_KhmvxztFYeQjTTHdxKajkcs&usqp=CAU",
      name: "L Singh",
      position: "(Trainer)",
    },
    {
      url:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSyABtacOfSl8WS6TxLnDKIPRKqd7Pr2JUg5AGEg2LbYtX_KhmvxztFYeQjTTHdxKajkcs&usqp=CAU",
      name: "S Kumar",
      position: "(Trainer)",
    },
    {
      url:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSyABtacOfSl8WS6TxLnDKIPRKqd7Pr2JUg5AGEg2LbYtX_KhmvxztFYeQjTTHdxKajkcs&usqp=CAU",
      name: "A Kumar",
      position: "(Trainer)",
    },
    {
      url:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSyABtacOfSl8WS6TxLnDKIPRKqd7Pr2JUg5AGEg2LbYtX_KhmvxztFYeQjTTHdxKajkcs&usqp=CAU",
      name: "Sophia",
      position: "(Sr. Trainer)",
    },
    {
      url:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSyABtacOfSl8WS6TxLnDKIPRKqd7Pr2JUg5AGEg2LbYtX_KhmvxztFYeQjTTHdxKajkcs&usqp=CAU",
      name: "Monika",
      position: "(Trainer)",
    },
    {
      url:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSyABtacOfSl8WS6TxLnDKIPRKqd7Pr2JUg5AGEg2LbYtX_KhmvxztFYeQjTTHdxKajkcs&usqp=CAU",
      name: "Sapna",
      position: "(Trainer)",
    },
    // {
    //   url:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSyABtacOfSl8WS6TxLnDKIPRKqd7Pr2JUg5AGEg2LbYtX_KhmvxztFYeQjTTHdxKajkcs&usqp=CAU",
    //   name: "Sophia",
    //   position: "(Managing Director)",
    // },
    // {
    //   url:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSyABtacOfSl8WS6TxLnDKIPRKqd7Pr2JUg5AGEg2LbYtX_KhmvxztFYeQjTTHdxKajkcs&usqp=CAU",
    //   name: "Sophia",
    //   position: "(Managing Director)",
    // },
    // {
    //   url:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSyABtacOfSl8WS6TxLnDKIPRKqd7Pr2JUg5AGEg2LbYtX_KhmvxztFYeQjTTHdxKajkcs&usqp=CAU",
    //   name: "Sophia",
    //   position: "(Admin)",
    // },
    // {
    //   url:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSyABtacOfSl8WS6TxLnDKIPRKqd7Pr2JUg5AGEg2LbYtX_KhmvxztFYeQjTTHdxKajkcs&usqp=CAU",
    //   name: "Sophia",
    //   position: "(Admin)",
    // },
    // {
    //   url:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSyABtacOfSl8WS6TxLnDKIPRKqd7Pr2JUg5AGEg2LbYtX_KhmvxztFYeQjTTHdxKajkcs&usqp=CAU",
    //   name: "Solpha",
    //   position: "(Managing Director)",
    // },
    // {
    //   url:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSyABtacOfSl8WS6TxLnDKIPRKqd7Pr2JUg5AGEg2LbYtX_KhmvxztFYeQjTTHdxKajkcs&usqp=CAU",
    //   name: "Sophia",
    //   position: "(Admin)",
    // },
  
 
   ]